import {
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
  ADD_CATEGORY_REQUEST,
  ADD_CATEGORY_SUCCESS,
  ADD_CATEGORY_FAILURE,
  UPDATE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_FAILURE,
  DELETE_CATEGORY_REQUEST,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAILURE
} from '../types/authTypes';
import axiosInstance from '../../utils/setupAxios';

// Fetch Categories
export const fetchCategoriesRequest = () => ({
  type: FETCH_CATEGORIES_REQUEST
});

export const fetchCategoriesSuccess = (data) => ({
  type: FETCH_CATEGORIES_SUCCESS,
  payload: data
});

export const fetchCategoriesFailure = (error) => ({
  type: FETCH_CATEGORIES_FAILURE,
  payload: error
});

export const fetchCategories = (params = {}) => {
  return async (dispatch) => {
    dispatch(fetchCategoriesRequest());
    try {
      const response = await axiosInstance.get('/songs/categories', { params });
      if (response.data.success) {
        dispatch(fetchCategoriesSuccess(response.data.data));
      } else {
        dispatch(fetchCategoriesFailure(response.data.message || 'Failed to fetch categories'));
      }
    } catch (error) {
      dispatch(fetchCategoriesFailure(error.response?.data?.message || 'Failed to fetch categories'));
    }
  };
};

// Add Category
export const addCategoryRequest = () => ({
  type: ADD_CATEGORY_REQUEST
});

export const addCategorySuccess = (category) => ({
  type: ADD_CATEGORY_SUCCESS,
  payload: category
});

export const addCategoryFailure = (error) => ({
  type: ADD_CATEGORY_FAILURE,
  payload: error
});

export const addCategory = (categoryData) => {
  return async (dispatch) => {
    dispatch(addCategoryRequest());
    try {
      const response = await axiosInstance.post('/songs/categories', categoryData);
      if (response.data.success) {
        dispatch(addCategorySuccess(response.data.data));
      } else {
        dispatch(addCategoryFailure(response.data.message || 'Failed to add category'));
      }
    } catch (error) {
      dispatch(addCategoryFailure(error.response?.data?.message || 'Failed to add category'));
    }
  };
};

// Update Category
export const updateCategoryRequest = () => ({
  type: UPDATE_CATEGORY_REQUEST
});

export const updateCategorySuccess = (category) => ({
  type: UPDATE_CATEGORY_SUCCESS,
  payload: category
});

export const updateCategoryFailure = (error) => ({
  type: UPDATE_CATEGORY_FAILURE,
  payload: error
});

export const updateCategory = (id, categoryData) => {
  return async (dispatch) => {
    dispatch(updateCategoryRequest());
    try {
      // If categoryData is FormData, add the id to it
      if (categoryData instanceof FormData) {
        categoryData.append('id', id);
        const response = await axiosInstance.post(`/songs/categories/update`, categoryData);
        if (response.data.success) {
          dispatch(updateCategorySuccess(response.data.data));
        } else {
          dispatch(updateCategoryFailure(response.data.message || 'Failed to update category'));
        }
      } else {
        // Handle regular object for backward compatibility
        const data = {id: id, ...categoryData};
        const response = await axiosInstance.post(`/songs/categories/update`, data);
        if (response.data.success) {
          dispatch(updateCategorySuccess(response.data.data));
        } else {
          dispatch(updateCategoryFailure(response.data.message || 'Failed to update category'));
        }
      }
    } catch (error) {
      dispatch(updateCategoryFailure(error.response?.data?.message || 'Failed to update category'));
    }
  };
};

// Delete Category
export const deleteCategoryRequest = () => ({
  type: DELETE_CATEGORY_REQUEST
});

export const deleteCategorySuccess = (id) => ({
  type: DELETE_CATEGORY_SUCCESS,
  payload: id
});

export const deleteCategoryFailure = (error) => ({
  type: DELETE_CATEGORY_FAILURE,
  payload: error
});

export const deleteCategory = (id) => {
  return async (dispatch) => {
    dispatch(deleteCategoryRequest());
    try {
      const data = {id: id};
      await axiosInstance.post(`/songs/categories/delete`, data);
      dispatch(deleteCategorySuccess(id));
    } catch (error) {
      dispatch(deleteCategoryFailure(error.response?.data?.message || 'Failed to delete category'));
    }
  };
}; 